import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import SignedAudioPlayer from '../aws/SignedAudioPlayer';
/**
 * Implements a preview of an Asset.  For images this is a thumb, for videos/audios it
 * is a key frame.  For other types it might be an icon or something similar.
 * @param asset to preview.
 * @returns JSX component
 */
const AssetAudioPlayer = ({ asset, ...otherProps }) => (_jsx(SignedAudioPlayer, { bucket: asset && asset.repository && asset.repository.bucket ? asset.repository.bucket : null, path: asset && asset.path ? `${asset.path}/original` : null, ...otherProps }));
export default observer(AssetAudioPlayer);
//# sourceMappingURL=AssetAudioPlayer.js.map